import React, { useState } from 'react';
import styled from 'astroturf/react';
import { Body } from 'js/design_system/Body';
import { LikesMenu } from 'js/social/UserListMenu/LikesMenu';
import { ResourceType } from 'js/social/shared/types';
import { LinkButton } from 'js/social/shared/design_system/LinkButton';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: -1px;
`;

const Separator = styled(Body)`
  color: #91919e;
`;

const CountText = styled(Body)`
  color: $ds-black;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

interface Props {
  id: number | string;
  liked: boolean;
  likeCount: number;
  replyCount: number;
  className?: string;
  hideReplyAction?: boolean;
  likeComment: () => Promise<void>;
  unlikeComment: () => Promise<void>;
  onReplyClick: () => void;
  onReplyCountClick: () => void;
}

const Cta: React.FunctionComponent<Props> = ({
  id,
  liked,
  likeCount,
  replyCount,
  className,
  hideReplyAction,
  likeComment,
  unlikeComment,
  onReplyClick,
  onReplyCountClick,
}) => {
  const [disableLike, setDisableLike] = useState(false);

  const onLikeClicked = () => {
    setDisableLike(true);
    likeComment().finally(() => setDisableLike(false));
  };
  const onUnlikeClicked = () => {
    setDisableLike(true);
    unlikeComment().finally(() => setDisableLike(false));
  };

  return (
    <Container className={className}>
      <LinkButton
        disabled={disableLike}
        onClick={liked ? onUnlikeClicked : onLikeClicked}
      >
        {liked ? 'Liked' : 'Like'}
      </LinkButton>
      {likeCount > 0 && (
        <LikesMenu
          resourceId={id}
          resourceType={ResourceType.Comment}
          liked={liked}
        >
          <CountText size="sm">{likeCount}</CountText>
        </LikesMenu>
      )}

      {!hideReplyAction && (
        <>
          <Separator size="sm">•</Separator>
          <LinkButton onClick={onReplyClick}>Reply</LinkButton>
        </>
      )}
      {replyCount > 0 && (
        <CountText size="sm" onClick={onReplyCountClick}>
          {replyCount}
        </CountText>
      )}
    </Container>
  );
};

export default Cta;
